module.exports = __webpack_public_path__ + "fonts/roboto-v15-latin-700italic.woff2";


//////////////////
// WEBPACK FOOTER
// ./web/fonts/roboto-v15-latin-700italic.woff2
// module id = 813
// module chunks = 0